/*
 * Controller for TrackerBase Main Page Navbar
 * Angular.module: trackerbase-app.views.main-page.tb-main-page-navbar
 * Controller name: tbMainPageNavBarCtrl
 *
 */

import TbAppConstants from "tbClient/config/tbAppConstants";

import Assert from "tbAssert";

import ngSanitize from "angular-sanitize";
import uiRouter from "@uirouter/angularjs";
import uiBootstrap from "angular-ui-bootstrap";

import AuthServiceModule from "tbClient/services/auth";
import TbAppConfigDataServiceModule from "tbClient/config/tb-app-config/TbAppConfigDataService";

import NavbarSearchWidgetComponent from "./NavbarSearchWidget";
import CreateTrackingEventLauncherComponent from "tbClient/views/create-tracking-event-dialog";
import UserInfoServiceModule from "tbClient/services/UserInfoService";
import TbUserAuthComponentModule from "tbClient/directives/user-auth";

const mIsCollapsed = new WeakMap();
const mShowTbVersion = new WeakMap();
const mAnchorScrollSvc = new WeakMap();
const mScopeSvc = new WeakMap();
const mLogSvc = new WeakMap();
const mUserInfoSvc = new WeakMap();
const mAuthSvc = new WeakMap();

const mInDebugMode = new WeakMap();

class MainPageNavbarController {
    constructor($scope, $anchorScroll, $log, TbAuthService, UserInfoService, TbAppConfigDataService) {

        Assert.StrictAssert($scope != null, "Assertion Failure: Missing Scope Service Dependency");
        Assert.StrictAssert($anchorScroll != null, "Assertion Failure: Missing Anchor Scroll Service Dependency");
        Assert.StrictAssert($log != null, "Assertion Failure: Missing Log Service Dependency");
        Assert.StrictAssert(TbAuthService != null, "Assertion Failure: Missing Auth Service Dependency");
        Assert.StrictAssert(UserInfoService != null, "Assertion Failure: Missing User Info Service Dependency");
        Assert.StrictAssert(TbAppConfigDataService != null, "Assertion Failure: Missing TrackerBase Application Configuration Data Service Dependency");

        mAnchorScrollSvc.set(this, $anchorScroll);
        mScopeSvc.set(this, $scope);
        mLogSvc.set(this, $log);
        mUserInfoSvc.set(this, UserInfoService);
        mAuthSvc.set(this, TbAuthService);

        mShowTbVersion.set(this, TbAppConfigDataService.tbShowVersionLabel);
        mInDebugMode.set(this, TbAppConfigDataService.tbEnableDebugMode);

        mIsCollapsed.set(this, true);
    }

    $onInit() {
        const inDebugMode = mInDebugMode.get(this);
        if (inDebugMode) {
            mUserInfoSvc.get(this).logUserRights();
        }

        mScopeSvc.get(this).$watch(
            () => this.isSignedIn,
            (newVal, oldVal) => {
                if (newVal !== oldVal) {

                    mUserInfoSvc.get(this).reload()
                        .then(() => {
                            this.userInfo.logUserRights();
                        })
                        .catch((err) => {
                            if (inDebugMode) {
                                mLogSvc.get(this).debug(`Could not reload user info service: ${err.message}`);
                            }
                        });
                }
            }
        );

        const mainNavBarElementIdSelector = `#${TbAppConstants.mainNavBarElementId}`;
        mAnchorScrollSvc.get(this).yOffset = angular.element(mainNavBarElementIdSelector);
    }

    get isCollapsed() {
        return mIsCollapsed.get(this);
    }

    set isCollapsed(updatedVal) {
        mIsCollapsed.set(this, updatedVal);
    }

    get showTbVersion() {
        return mShowTbVersion.get(this);
    }

    set showTbVersion(updatedVal) {
        mShowTbVersion.set(this, updatedVal);
    }

    get userInfo() {
        return mUserInfoSvc.get(this);
    }

    get isSignedIn() {
        return mAuthSvc.get(this).isAuthenticated();
    }
}

MainPageNavbarController.$inject = [
    "$scope",
    "$anchorScroll",
    "$log",
    "TbAuthService",
    "UserInfoService",
    "TbAppConfigDataService"
];

MainPageNavbarController.template = require("./MainPageNavbar.tpl.html");
MainPageNavbarController.controllerAs = "tbMainNavBarCtrl";

MainPageNavbarController.dependencies = [
    ngSanitize,
    AuthServiceModule,
    uiBootstrap,
    uiRouter,
    UserInfoServiceModule,
    CreateTrackingEventLauncherComponent,
    NavbarSearchWidgetComponent,
    TbUserAuthComponentModule,
    TbAppConfigDataServiceModule
];

export default MainPageNavbarController;



//////////////////
// WEBPACK FOOTER
// ./src/views/main-page/MainPageNavbar/MainPageNavbarController.js
// module id = TsfA
// module chunks = 1